// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3wh3A","rootCenter":"LoadMoreObserver_rootCenter__Dd_DB","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1bHzI"};